module.exports = __webpack_public_path__ + "img/file-earmark-font.b5261afa.svg";